var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#BE7637"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 7.50015L14.5002 9.25015M11.5835 15.6668H16.2502M6.91683 13.3335L6.3335 15.6668L8.66683 15.0835L15.4253 8.32498C15.644 8.1062 15.7669 7.80951 15.7669 7.50015C15.7669 7.19079 15.644 6.8941 15.4253 6.67532L15.325 6.57498C15.1062 6.35627 14.8095 6.2334 14.5002 6.2334C14.1908 6.2334 13.8941 6.35627 13.6753 6.57498L6.91683 13.3335Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.66a53a4450d99cc7161c116ab389e2fd.svg";
export { ForwardRef as ReactComponent };